import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TagStore, SortType } from 'services/store/tags';
import { MobileTagDrawerListContainer } from '../../TagDrawer/mobile/MobileTagDrawerList';
import MobilePopularOrRecentSortingFilter from '../MobilePopularOrRecentSortingFilter';
import useStyles from './style';

type PropsType = {
  tagStore: TagStore;
  updateFilters: (appliedFilters: {
    minDuration: number | null | undefined;
    maxDuration: number | null | undefined;
    sortBy: Array<SortType>;
  }) => void;
};

const MobileFiltersDrawer = (props: PropsType): ReactElement => {
  const { tagStore, updateFilters } = props;
  const { appliedFilters } = tagStore;

  const classes = useStyles();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const updateSortingFilter = (sortingType: SortType): void => {
    updateFilters({
      minDuration: appliedFilters.min_Duration,
      maxDuration: appliedFilters.max_Duration,
      sortBy: [sortingType],
    });
  };

  const handleApplyFilters = () => {
    setIsOpen(false);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Button
        variant="outlined"
        onClick={() => setIsOpen(true)}
        fullWidth
        size="medium"
      >
        {t('filtersBar:mobile.showFilters')}
      </Button>

      <Drawer
        // from which side the drawer slides in
        anchor="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        data-testid="mobile-filters-drawer"
        sx={{ zIndex: '9999' }}
        PaperProps={{
          sx: {
            backgroundColor: '#292929',
            backgroundImage: 'none',
          },
        }}
      >
        {/* The inside of the drawer */}
        <Box
          sx={{
            width: '90vw',
            p: 2,
            height: 1,
          }}
          data-testid="mobile-filters"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h3">Filters</Typography>
            <IconButton onClick={() => setIsOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
          <div>
            <Box sx={{ mb: 4, mt: 4 }}>
              <MobilePopularOrRecentSortingFilter
                initialValue={SortType.Popular}
                onUpdate={(sortingType: SortType) => {
                  updateSortingFilter(sortingType);
                }}
              />
            </Box>
            <MobileTagDrawerListContainer />
          </div>
        </Box>
        <Box className={classes.buttonContainer}>
          <Button
            variant="contained"
            fullWidth
            size="medium"
            onClick={() => handleApplyFilters()}
          >
            {t('filtersBar:mobile.seeTracks')}
          </Button>
        </Box>
      </Drawer>
    </Box>
  );
};

export default MobileFiltersDrawer;
